import {
  SubmissionJob,
  SubmissionJobs,
} from "~/classes/models/submission-job/submission-job.model";

export const useSubmissionJobs = defineStore("submission-jobs", () => {
  const submissionJobs = ref<SubmissionJobs>([]);

  const addSubmissionJob = async (submissionJob: SubmissionJob) => {
    if (submissionJobs.value.find((job) => job.id == submissionJob.id)) {
      submissionJobs.value = [
        ...submissionJobs.value.filter((job) => job.id != submissionJob.id),
        submissionJob,
      ];
      return;
    }

    submissionJobs.value = [...submissionJobs.value, submissionJob];
    await nextTick();
    submissionJob.sheetController.open();
  };

  const removeSubmissionJob = (submissionJob: SubmissionJob) => {
    submissionJob.sheetController.close();
    submissionJobs.value = submissionJobs.value.filter(
      (job) => job.id != submissionJob.id
    );
  };

  return {
    submissionJobs,
    addSubmissionJob,
    removeSubmissionJob,
  };
});
